import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import ViewMessageContainer from './ViewMessageContainer';
import Layout from '../../components/Layout';
import NotFound from '../notFound/NotFound';
import UnderConstruction from './../../components_new/UnderConstruction';
import { Query } from 'react-apollo';
import GetThreadQuery from './GetThreadQuery.graphql';

const title = 'ViewMessage';

export default {
  path: '/inbox_old/:threadId?',

  action(arg) {
    const { store, params, query } = arg;
    // From Redux Store
    const isAuthenticated = store.getState().runtime.isAuthenticated;

    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    //log("is admin", isAdminAuthenticated);

    // From URL
    const threadId = Number(params.threadId);
    const userType = params.type;

    if (!isAdminAuthenticated) {
      if (!isAuthenticated) {
        return { redirect: '/login' };
      }
    }

    // if (isAdminAuthenticated) {
    return {
      title,
      component: (
        <UserLayout>
          <Query
            query={GetThreadQuery}
            variables={{ threadType: 'both', threadId }}
            skip={!threadId}
          >
            {({ data, error, loading }) => (
              <ViewMessageContainer
                userType={userType}
                focusedThread={data && data.getThread}
              />
            )}
          </Query>
        </UserLayout>
      ),
    };
    // } else {
    // return { redirect: '/login' };
    // }

    // return {
    //   title,
    //   component: <UserLayout><UnderConstruction comment='Messaging will be available soon!' /></UserLayout>,
    // };
  },
};



// WEBPACK FOOTER //
// ./src/routes/viewMessage/index.js